import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListSupportBenutzer extends GuiListGeneric {
    constructor() {
        super("SupportBenutzer");
    }
}
